import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {defaultStyles} from '../../components/Modal/modal.config';
import AppModal from '../../components/Modal/AppModal';
import {VoucherModal} from '../../components/VoucherModal/VoucherModal';
import {AllergyModal} from '../../components/AllergyModal/AllergyModal';
import {ALLERGY, VOUCHER} from '../../constants/modalType';

const ExtraInformation = ({
    closeModal,
    modalType,
    openAllergyModal,
    openVoucherModal,
    submitVoucher,
    voucherChange,
    voucherMessages,
    vouchersEnabled,
    voucherValue,
    basket
  }) => {
  const renderVoucherMessages =
    voucherMessages &&
    voucherMessages.map(
      voucherMessage =>
        voucherMessage && (
          <p key={voucherMessage.code}>
            <FormattedMessage
              id={voucherMessage.id}
              values={{value: voucherMessage.value}}
            />
          </p>
        )
    );

  const vouchers = basket && basket.promotions || null;
  const renderVoucher = vouchersEnabled && (
    <div>
      <p>
        <a
          href="#"
          onClick={openVoucherModal}
        >
          <FormattedMessage id="checkout.voucher" />
        </a>
      </p>
      {renderVoucherMessages}
    </div>
  );

  const renderVoucherModal = modalType === VOUCHER && (
    <AppModal
      customStyles={defaultStyles}
      callback={closeModal}
    >
      <VoucherModal
        submitVoucher={submitVoucher}
        voucherChange={voucherChange}
        voucherValue={voucherValue}
        vouchers={vouchers}
        voucherMessage={renderVoucherMessages}
      />
    </AppModal>
  );

  const renderAllergyModal = modalType === ALLERGY && (
    <AppModal
      customStyles={defaultStyles}
      callback={closeModal}
    >
      <AllergyModal />
    </AppModal>
  );

  return (
    <div>
      {renderVoucher}
      <p>
        <FormattedMessage id="checkout.cookieParagraph" />
      </p>
      <p>
        <a
          href="#"
          onClick={openAllergyModal}
        >
          <FormattedMessage id="checkout.allergy" />
        </a>
      </p>
      {renderAllergyModal}
      {renderVoucherModal}
    </div>
  );
};

ExtraInformation.propTypes = {
  closeModal: PropTypes.func.isRequired,
  modalType: PropTypes.string,
  openAllergyModal: PropTypes.func.isRequired,
  openVoucherModal: PropTypes.func.isRequired,
  submitVoucher: PropTypes.func.isRequired,
  voucherChange: PropTypes.func.isRequired,
  voucherMessages: PropTypes.array,
  vouchersEnabled: PropTypes.bool.isRequired,
  voucherValue: PropTypes.string,
  basket: PropTypes.object
};

export default ExtraInformation;



// WEBPACK FOOTER //
// ./containers/CheckoutPage/ExtraInformation.js